import {
  MAKE_INPUT,
  MODEL_INPUT,
  YEAR_INPUT,
  STYLE_INPUT,
  ZIP_CODE_INPUT,
} from 'client/site-modules/shared/utils/appraiser/appraiser-validation-helper';
import { DROPDOWN_NAMES } from 'site-modules/shared/components/vehicle-dropdowns/constants';

const getDropdownElByName = name => document.querySelector(`.vehicle-dropdowns [name="${name}"]`);

export const getFirstInputWithError = errorMap => {
  if (errorMap.get(MAKE_INPUT)) {
    return getDropdownElByName(DROPDOWN_NAMES.MAKE);
  }
  if (errorMap.get(MODEL_INPUT)) {
    return getDropdownElByName(DROPDOWN_NAMES.MODEL);
  }
  if (errorMap.get(YEAR_INPUT)) {
    return getDropdownElByName(DROPDOWN_NAMES.YEAR);
  }
  if (errorMap.get(STYLE_INPUT)) {
    return getDropdownElByName(DROPDOWN_NAMES.STYLE);
  }
  if (errorMap.get(ZIP_CODE_INPUT)) {
    return document.querySelector('.location-and-style-step [name="zip"]');
  }
  return null;
};

export const focusFirstInputWithError = errorMap => {
  const inputToFocus = getFirstInputWithError(errorMap);

  if (inputToFocus?.focus) {
    inputToFocus.focus();
  }
};
